<template>
  <AppLayout>
    <template #middle>
      <InnerContent>
        <ProgramSettingsContent :id="selectedProgramIdRef" />
      </InnerContent>
    </template>
  </AppLayout>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import AppLayout from '@/(routes)/(protected)/(app)/layout.vue'
import { selectGetSelectedProgramId } from '@/features/programs/stores/programs/programs.selectors'
import programsStore from '@/features/programs/stores/programs/programs.store'
import InnerContent from '@/features/ui/components/inner-content/inner-content.vue'
import ProgramSettingsContent from '@/features/ui/pages/admin/program-settings/program-settings-content.vue'
import { selectGetCurrentRoute } from '@/store/route/route.selector'
import routeStore from '@/store/route/route.store'

const currentRouteRef = selectGetCurrentRoute(routeStore)
const isNewRef = computed(() => currentRouteRef.value?.path.includes('new'))

const selectedProgramIdRef = computed(() => (isNewRef.value ? '' : selectGetSelectedProgramId(programsStore).value))
</script>
